import { useState, type FormEvent } from 'react';
import { createAccount } from '@/db/repositories/accountRepository';
import { Actions, Field, Modal, field, parseAmount } from './ui';

const TYPES: { value: string; label: string }[] = [
  { value: 'checking', label: 'Conta corrente' },
  { value: 'savings', label: 'Poupança' },
  { value: 'wallet', label: 'Carteira (dinheiro)' },
  { value: 'digital', label: 'Conta digital' },
  { value: 'investment', label: 'Investimento' },
  { value: 'other', label: 'Outra' },
];

export function AccountForm({ onClose, onSaved }: { onClose: () => void; onSaved: () => Promise<void> }) {
  const [name, setName] = useState('');
  const [type, setType] = useState('checking');
  const [initial, setInitial] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(e: FormEvent) {
    e.preventDefault();
    if (!name.trim()) { setError('Dê um nome à conta.'); return; }
    const initialBalance = initial.trim() ? parseAmount(initial) : 0;
    if (!Number.isFinite(initialBalance)) { setError('Saldo inicial inválido.'); return; }
    setBusy(true); setError(null);
    try {
      await createAccount({ name: name.trim(), type, initialBalance } as Parameters<typeof createAccount>[0]);
      await onSaved();
    } catch (err) { setError(err instanceof Error ? err.message : String(err)); setBusy(false); }
  }

  return (
    <Modal title="Nova conta" onClose={onClose} testId="account-form">
      <form onSubmit={submit} className="mt-4 space-y-4">
        <Field text="Nome"><input value={name} onChange={(e) => setName(e.target.value)} placeholder="Ex.: Nubank" className={field} data-testid="account-name" autoFocus /></Field>
        <Field text="Tipo"><select value={type} onChange={(e) => setType(e.target.value)} className={field}>{TYPES.map((t) => <option key={t.value} value={t.value}>{t.label}</option>)}</select></Field>
        <Field text="Saldo inicial"><input inputMode="decimal" value={initial} onChange={(e) => setInitial(e.target.value)} placeholder="0,00" className={field} data-testid="account-initial" /></Field>
        {error && <p className="rounded-xl bg-neg-pale px-3 py-2 text-[13px] text-neg">{error}</p>}
        <Actions busy={busy} onCancel={onClose} submitLabel="Criar conta" />
      </form>
    </Modal>
  );
}
